module.exports = __webpack_public_path__ + "static/media/award.9b0affb8.svg";